import { render } from "./PaywallLivePreview.vue?vue&type=template&id=81d3a612"
import script from "./PaywallLivePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallLivePreview.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallLivePreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81d3a612"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81d3a612', __exports__)) {
    api.reload('81d3a612', __exports__)
  }
  
  module.hot.accept("./PaywallLivePreview.vue?vue&type=template&id=81d3a612", () => {
    api.rerender('81d3a612', render)
  })

}


export default __exports__